const BYTEDANCE_REPLACEMENT_DOMAIN = {
    "rayjump.com":"mtgglobals.com",
    "mintegral.net":"mtgglobals.com",
}

const EG_REPLACEMENT_DOMAIN = {
    "rayjump.com":"mintegral.net"
}

export {
    BYTEDANCE_REPLACEMENT_DOMAIN,
    EG_REPLACEMENT_DOMAIN
}